import React from "react";
import { COLORS } from "../../definitions/colors";
import styled from "styled-components";
import Logo from "./Logo";
import NavOption from "./NavOption";

const Header = styled.header`
  /* position: relative; */
  /* float: left; */
  position: fixed;
  z-index: 999;
  margin: 0;
  padding: 0;
  width: 100%;
  background-color: ${COLORS.headerBackground};
  `

  const Line = styled.hr`
  position: relative;
  float: left;
  background-color: ${COLORS.accent};
  padding: 0;
  margin: 0;
  width: 100%;
  border: 0.1rem solid ${COLORS.accent};
`;

  const NavHolder = styled.div`
    display: grid;
    grid-template-columns: 1fr auto 1fr;
    position: relative;
    width: 80%;
    margin: auto;
    padding: 5px 0 5px 0;
    align-items: center;
    gap: 2rem;

    @media (max-width: 758px) {
      display: flex;
      justify-content: center;
      flex-direction: column;
      gap: 0;
      padding: 2px 0 2px 0;
    }
  `

  const LeftNav = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 2rem;

    @media (max-width: 758px) {
      display: contents;
    }
  `

  const RightNav = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 2rem;

    @media (max-width: 758px) {
      display: contents;
    }
  `

  const LogoContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;

    @media (max-width: 758px) {
      padding: 0.5rem 0;
    }
  `

  const ContactInfo = styled.div`
    display: none;
    
    @media (max-width: 758px) {
      display: block;
      text-align: center;
      font-size: 0.85rem;
      color: ${COLORS.blackText};
      margin-top: 0.3rem;
      padding: 0;
      line-height: 1.2;
    }
  `

  const DesktopContactInfo = styled.div`
    font-size: 0.9rem;
    color: ${COLORS.blackText};
    text-align: left;

    @media (max-width: 758px) {
      display: none;
    }
  `

  const ContactLabel = styled.div`
    font-size: 0.85rem;
    opacity: 0.8;
    margin-bottom: 0.2rem;
  `

  const PhoneLink = styled.a`
    color: ${COLORS.blackText};
    text-decoration: none;
    font-weight: bold;
    transition: opacity 0.3s;

    &:hover {
      opacity: 0.7;
    }
  `

const Navigation = () => {
    return (
      <Header>
        <Line />
        <NavHolder>
          <LeftNav>
            <NavOption icon="/icons/breads.png" text="Chleby" dest="/chleby" className="desktop-only"></NavOption>
            <NavOption icon="/icons/bread.png" text="Bułki" dest="/bulki" className="desktop-only"></NavOption>
          </LeftNav>
          <LogoContainer>
            <Logo />
            <ContactInfo>
              Zamówienia telefoniczne: <PhoneLink href="tel:+004796724953">+0047 96724953</PhoneLink>
            </ContactInfo>
          </LogoContainer>
          <RightNav>
            <NavOption icon="/icons/cinnamon-roll.png" text="Słodkości" dest="/slodkosci" className="desktop-only"></NavOption>
            <NavOption icon="/icons/mason-jar.png" text="Inne" dest="/inne" className="desktop-only"></NavOption>
            <DesktopContactInfo>
              <ContactLabel>Zamówienia telefoniczne:</ContactLabel>
              <PhoneLink href="tel:+004796724953">+0047 96724953</PhoneLink>
            </DesktopContactInfo>
          </RightNav>
         </NavHolder>
         <Line />
       </Header>
    );
  }

export default Navigation;
